<template>
  <document-registry-page
    fixed-document-type="payment"
    page-title="Платежные поручения"
    :payments="true"
    :payment-context="paymentContext"
  />
</template>

<script>
import DocumentRegistryPage from '../documents/DocumentRegistryPage.vue'

export default {
  name: 'payments_list',
  components: { DocumentRegistryPage },
  props: {
    paymentContext: { type: String, default: 'bank' }
  }
}
</script>
